var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-pdv"},[_c('PageHeader',{attrs:{"title":_vm.i18nAmountMonthlyEvolution}}),_c('div',{staticClass:"card-body",staticStyle:{"height":"300px"}},[_c('stacked-column-full-chart',{attrs:{"series-prop":_vm.series,"categories-series-prop":_vm.categories,"busy":_vm.loading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }